export default __webpack_public_path__ + "static/media/X8000G6I.8a163570.jpg";